import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = (smallScreen: any, matches: any) =>
  makeStyles<Theme>((theme: Theme) => ({
    filterMainContainer: {
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: "#FFFFFF",
      marginTop: "20px",
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px",
    },
    paper: {
      width: smallScreen ? "170px" : "30vw",
      textAlign: "center",
      borderRadius: "5px",
      family: "'Poppins', sans-serif",
      border: "1px solid  #b3b3b3",
    },
    count: {
      fontSize: smallScreen ? "30px" : "20px",
      color: "#212121",
      margin: "0px 0px -8px 0px",
      fontWeight: "bold",
      padding: smallScreen ? "0px 30px" : "0px 12px",
      family: "'Poppins', sans-serif",
    },
    text: {
      fontWeight: 600,
      margin: "0px 0px 5px 0px",
      fontSize: "12px",
      family: "'Poppins', sans-serif",
      color: "#737373",
    },
    chartMainContainer: {
      display: "flex",
      flexDirection: matches ? "row" : "column",
      alignItems: "center",
      justifyContent: "space-evenly",
      backgroundColor: "#FFFFFF",
      padding: "10px",
    },
  }));

export default useStyles;
